import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import * as BullCache from "../../util/BullCache";
import { SocketConfigService } from '../../services/SocketConfigService';

function SocketConfig() {

    var user = BullCache.getFromCache("user");

    const [loading, setLoading] = useState(false); 
    const [socketConfigList, setSocketConfigList] = useState([]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const fetchSocketConfigList = () => {
        setLoading(true);     
        SocketConfigService.getSocketConfigs({ 'loginId': user.adminId }).then(res => {
        setLoading(false);
            if (res.code === 1) {
                setSocketConfigList(res.data.socketList);
            }
        });
    };

    useEffect(() => {
      fetchSocketConfigList();  
    }, []); 



    const handleClose = () => {
        setShowModal(false);
    };

      useEffect(() => {
        const handleEditClick = (event) => {
            const rowId = event.target.getAttribute("data-id");
            const rowData = socketConfigList[rowId]; 
            setSelectedItem(rowData);
            setShowModal(true); 
        };

        const handleStatusClick = (event) => {
            const rowId = event.target.getAttribute("data-id");
            const rowData = socketConfigList[rowId]; 

            if(rowData !== null && rowData !== undefined) {
             Swal.fire({
                    title: 'Are you sure?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: rowData.active ? 'Disconnect' : 'Connect',
                    cancelButtonText: 'No',
                    cancelButtonColor: "#d33",
                    confirmButtonColor: "#198754"
                  }).then((result) => {
                    if (result.isConfirmed) {
                      var request = {
                        loginId: user.adminId,
                        socketConfigId: rowData.socketConfigId,
                        active: !rowData.active
                      }

                      setLoading(true);
                       SocketConfigService.changeStatus(request).then(res => {
                        setLoading(false);
                            if (res.code === 1) {
                                 Swal.fire({
                                    icon: "success",
                                    text: "Success.."
                                });
                                fetchSocketConfigList();
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: res.messages
                                });
                            } 
                        });
                    }
                  });
            }

        };

        const handleReloadClick = (event) => {
            const rowId = event.target.getAttribute("data-id");
            const rowData = socketConfigList[rowId]; 
             if(rowData !== null && rowData !== undefined) {
                handleRefreshClick(rowData.name);
             }
        };

        document.addEventListener("click", (event) => {
            if (event.target.classList.contains("icon-pencil")) {
                handleEditClick(event);
            } else  if (event.target.classList.contains("status")) {
                handleStatusClick(event);
            } else  if (event.target.classList.contains("reload")) {
                handleReloadClick(event);
            }
        });

        return () => {
            document.removeEventListener("click", handleEditClick);
            document.removeEventListener("click", handleStatusClick);
            document.removeEventListener("click", handleReloadClick);
        };


    }, [socketConfigList]);
    
    const handleRefreshClick = async (value) => {
         Swal.fire({
                    title: 'Are you sure?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    cancelButtonColor: "#d33",
                    confirmButtonColor: "#198754"
                  }).then((result) => {
                    if (result.isConfirmed) {
                        setLoading(true);
                        var request = {
                                loginId: user.adminId,
                                keyword: value,
                            }

                        SocketConfigService.reload(request).then(res => {
                        setLoading(false);
                            if (res.code === 1) {
                                Swal.fire({
                                icon: "success",
                                text: "Refreshed!!.."
                                });
                            } else {
                                Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: res.messages ||"Something Went to Wrong!",
                                });
                            }    
                        });
                    }
                });

    }; 
    
    const handleTrueDataRefreshClick = async (value) => {
         Swal.fire({
                    title: 'Are you sure?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    cancelButtonColor: "#d33",
                    confirmButtonColor: "#198754"
                  }).then((result) => {
                    if (result.isConfirmed) {
                        setLoading(true);
                        var request = {
                                keyword: value
                            }

                        // SocketConfigService.trueDataReload(request).then(res => {
                        // setLoading(false);
                        //     if (res.code === 1) {
                        //         Swal.fire({
                        //         icon: "success",
                        //         text: "Refreshed!!.."
                        //         });
                        //     } else {
                        //         Swal.fire({
                        //         icon: "error",
                        //         title: "Oops...",
                        //         text: res.messages ||"Something Went to Wrong!",
                        //         });
                        //     }    
                        // });
                    }
                });

    };     

    const handleSaveChanges = () => {

            selectedItem.loginId = user.adminId;

            SocketConfigService.updateSocketConfig(selectedItem)
                .then(res => {
                    if (res.code === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Updated Successfully!!.."
                        });
                        setShowModal(false);  
                        fetchSocketConfigList();
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: res.messages || "Failed to update!"
                        });
                    }
                })
                .catch(error => {
                    alert('Error updating data.');  
                });
        };
    

    
    const columns = [
      {
         title: 'SERVER',
         data: 'name',
         className: 'font-bold'
      },
      { 
        title: 'SEGMENT', 
        data: 'segment', 
        className: 'font-bold text-nowrap',
        render: (data, type, row, full, meta) => {
            if(data === undefined) {
                return '';
            }
            return data;
        }
      },
        { 
            title: 'ENDPOINT', 
            data: 'endPoint', 
            className: 'font-bold',
            render: (data, type, row, full, meta) => {
                if(data === undefined) {
                    return '';
                }
                return data;
            }
        },
        
      {
            title: 'USERNAME',
            data: 'userName',
            className: 'font-bold',
            render: (data, type, row, full, meta) => {
            if(data === undefined) {
                return '';
            }
            return data;
        }
      },
      {
        title: 'PASSWORD',
        data: 'password',
        className: 'font-bold ' ,
        render: (data, type, row, full, meta) => {
            if(data === undefined) {
                return '';
            }
            return data;
        }
      },
         {
        title: 'TOKEN',
        data: 'token',
        className: 'font-bold text-nowrap' ,
        render: (data, type, row, full, meta) => {
            if(data === undefined) {
                return '';
            }
            return data;
        }
      },
      {
         title: 'LAST UPDATED', 
         data: 'auditTimestamp',    
         className: 'font-bold text-nowrap',
         render: (data, type, row, full, meta) => {
            if(data === undefined) {
                return '';
            }
            return data;
        }
      },
      {
         title: 'STATUS', 
         data: 'active',    
         className: 'font-bold text-nowrap',
         render: (data, type, row, full, meta) => {
            if(data === undefined) {
                return '';
            }
            const variant = data ? 'btn-success' : 'btn-outline-danger';
             return `
            <button class="btn ${variant} btn-sm status" data-id="${full.row}" style="cursor: pointer"> ${data ? 'Connected' : 'Disconnected'}</button>
            ${data ? `<button class="btn btn-sm blue-background-white-text reload" data-id="${full.row}" style="cursor: pointer">Reload</button>` : ''}
            `;
        }
      },
      {
        title: "EDIT",
        className: " font-bold fss-1 ",
        data: 'socketConfigId',
        render: (data, type, row, full, meta) => {
          return `
          <i class="me-3 fa fa-pencil icon-pencil" data-id="${full.row}" style="cursor: pointer"></i>
        `;
        },
      }, 
    ]


    return (
        <div>

            <Row>
                <Col xl={2} xs={6} md={2} className='ms-1'>
                     <Button className="mt-2 fa fa-refresh blue-background-white-text fss-09" size="lg" onClick={() => handleRefreshClick('ALL')}>&nbsp; Relaod all</Button>
                </Col>
                {/* <Col xl={2} xs={6} md={2} className='ms-1'>
                     <Button className="mt-2 fa fa-refresh blue-background-white-text fss-09" size="lg" onClick={() => handleTrueDataRefreshClick('TRUE DATA')}>&nbsp; Relaod True Data</Button>
                </Col> */}
            </Row>

            <Card className="mt-2 mb-5">
                <Card.Body className='ps-1'>
                    <div className="table-responsive">
                        {loading ? (
                            <div className="container vh-100">
                                <div className="d-flex align-items-center justify-content-center h-90">
                                    <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <DataTable
                                id="table"
                                className=" table  table-bordered bg-header fss-08 white-bordered-table"
                                columns={columns}
                                data={socketConfigList}
                                 options={{
                                    language: {
                                        emptyTable: 'No Data Found',
                                        lengthMenu: '_MENU_',
                                    },
                                    dom: '<"datatable-toolbar"lf>rtip',
                                }}

                            />
                        )}
                    </div>
                </Card.Body>
            </Card>


            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Socket Config</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedItem && (
                        <Form>
                            <div className='text-center'>
                                 <label className='fss-09'> <span className='text-green'>SERVER:</span> {selectedItem.name}</label>
                            </div>
                            <Form.Group controlId="formMarket">
                                <Form.Label className='fss-09 text-green'>SEGMENT</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={selectedItem.segment}
                                     onChange={(e) => {
                                        setSelectedItem({ ...selectedItem, segment: e.target.value });
                                    }}
                                />
                            </Form.Group>

                            <Form.Group controlId="formScript" className='mt-2'>
                                <Form.Label className='fss-09 text-green'>ENDPOINT</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={selectedItem.endPoint}
                                    onChange={(e) => {
                                        setSelectedItem({ ...selectedItem, endPoint: e.target.value });
                                    }}
                                />
                            </Form.Group>

                            <Form.Group controlId="formQuantity"  className='mt-2'>
                                <Form.Label className='fss-09 text-green'>USERNAME</Form.Label >
                                <Form.Control
                                    type="text"
                                    value={selectedItem.userName}
                                    onChange={(e) => {
                                        setSelectedItem({ ...selectedItem, userName: e.target.value });
                                    }}
                                />
                            </Form.Group>

                            <Form.Group className='mt-2'>
                                <Form.Label className='fss-09 text-green'>PASSWORD</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={selectedItem.password}
                                    onChange={(e) => {
                                        setSelectedItem({ ...selectedItem, password: e.target.value });
                                    }}
                                />
                            </Form.Group>

                            <Form.Group className='mt-2'>
                                <Form.Label className='fss-09 text-green'>TOKEN</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={selectedItem.token}
                                    onChange={(e) => {
                                        setSelectedItem({ ...selectedItem, token: e.target.value });
                                    }}
                                />
                            </Form.Group>
                        </Form>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="success" onClick={handleSaveChanges}>
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}
export default SocketConfig;